import { render, staticRenderFns } from "./BodyDeDados.vue?vue&type=template&id=6b316510&scoped=true"
import script from "./BodyDeDados.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyDeDados.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BodyDeDados.vue?vue&type=style&index=0&id=6b316510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b316510",
  null
  
)

export default component.exports